import { Card, CardBody, CardTitle, Container, Row, Col } from "reactstrap";

const ReferralStatsCards = ({ usersData }) => {
    const totalUsers = usersData.length;
    const usersWithReferrals = usersData.filter(
        (user) => user.referredCount && user.referredCount > 0
    ).length;
    
    const totalReferrals = usersData.reduce(
        (sum, user) => sum + (user.referredCount || 0),
        0
    );
    
    const usersWithLimits = usersData.filter(
        (user) => user.referredLimit && user.referredLimit > 0
    ).length;
    
    const averageReferrals = totalUsers > 0 ? (totalReferrals / totalUsers).toFixed(1) : 0;
    
    const maxReferrals = usersData.reduce(
        (max, user) => Math.max(max, user.referredCount || 0),
        0
    );

    const stats = [
        {
            title: "Total Users",
            value: totalUsers,
            icon: "ni ni-single-02 text-primary",
            color: "info",
        },
        {
            title: "Users with Referrals",
            value: usersWithReferrals,
            icon: "ni ni-satisfied text-success",
            color: "success",
        },
        {
            title: "Total Referrals",
            value: totalReferrals,
            icon: "ni ni-chart-bar-32 text-info",
            color: "info",
        },
        {
            title: "Users with Limits",
            value: usersWithLimits,
            icon: "ni ni-lock-circle-open text-warning",
            color: "warning",
        },
        {
            title: "Average Referrals",
            value: averageReferrals,
            icon: "ni ni-chart-pie-35 text-primary",
            color: "primary",
        },
        {
            title: "Max Referrals",
            value: maxReferrals,
            icon: "ni ni-trophy text-success",
            color: "success",
        },
    ];

    return (
        <Container className="mt--7" fluid>
            <Row>
                {stats.map((stat, index) => (
                    <Col
                        lg="6"
                        xl="4"
                        key={index}
                        style={{ marginBottom: "15px" }}
                    >
                        <Card className="card-stats mb-4 mb-xl-0">
                            <CardBody>
                                <Row>
                                    <div className="col">
                                        <CardTitle
                                            tag="h5"
                                            className="text-uppercase text-muted mb-0"
                                        >
                                            {stat.title}
                                        </CardTitle>
                                        <span className="h2 font-weight-bold mb-0">
                                            {stat.value}
                                        </span>
                                    </div>
                                    <Col className="col-auto">
                                        <div
                                            className={`icon icon-shape bg-${stat.color} text-white rounded-circle shadow`}
                                        >
                                            <i className={stat.icon} />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default ReferralStatsCards;